<template>
    <b-badge variant="info">
        <feather-icon icon="EyeIcon" size="12" class="mr-25" />
        {{ field }}
    </b-badge>
</template>

<script>
import { BBadge } from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";

export default {
    name: "ViewCountBadge",
    components: {
        BBadge,
        FeatherIcon,
    },
    props: {
        field: {
            type: [Number, String],
            default: 0,
        },
        row: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
